module.exports = "/static/assets/89dcd810c06d1dce0b6113e84bc6d1f1.png";